var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinLine = function SvgCoinLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.06 6.901c3.861 3.862 5.285 8.7 3.178 10.807l-2.543 2.543c-2.107 2.107-6.945.684-10.807-3.178C4.095 13.28 2.654 8.545 4.6 6.38l.11-.115 2.543-2.543C9.359 1.616 14.198 3.04 18.06 6.9M10.43 14.53c-2.365-2.365-3.816-5.097-4.1-7.342l-.35.35c-1.196 1.196-.074 5.01 3.179 8.263 3.185 3.185 6.909 4.328 8.186 3.25l.078-.071.35-.35c-2.245-.284-4.978-1.735-7.343-4.1m6.357-6.357C13.535 4.92 9.72 3.798 8.524 4.994s-.074 5.012 3.179 8.265c3.252 3.252 7.067 4.374 8.264 3.178s.074-5.011-3.179-8.264"
  })));
};
export default SvgCoinLine;